"use client";
import { useEffect, useState } from "react";

interface IMediaPlayerProps {
  src: string;
  fileName: string;
  className?: string;
}

export function MediaPlayer({ src, fileName, className }: IMediaPlayerProps) {
  const [mediaType, setMediaType] = useState<string>("");

  useEffect(() => {
    const audioFormats = [".mp3", ".m4a", ".wav"];
    const extension = fileName?.substring(fileName?.lastIndexOf("."));
    setMediaType(audioFormats.includes(extension) ? "audio" : "video");
  }, [fileName]);

  return (
    <>
      {mediaType === "video" ? (
        <video
          controls
          className={`${className || ""} max-h-[400px] w-full max-w-lg`}
        >
          <source src={src} type="video/mp4" />
        </video>
      ) : (
        <div className="pr-10">
          <audio
            controls
            preload="metadata"
            className="h-[45px] min-w-[200px] md:min-w-[300px] w-full"
          >
            <source src={src} type="audio/mpeg" />
          </audio>
        </div>
      )}
    </>
  );
}
